module.exports = __webpack_public_path__ + "static/img/icon01.bd9c335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/culture/icon01.png
// module id = /OEW
// module chunks = 1